import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import LabeledDropdown from "./LabeledDropdown";
import PieChartComponent from "./PieChartComponent";
import {
  getAllFamilyDistrict,
  getAllFamilyUphcOrPhc,
  getAllFamilyTaluka,
  getAllFamilySubcenter,
  getAllFamilyLgb,
  getAllFamilyVillageOrSubarea,
  getAllFamilyEligibleCouple,
  getAllFamilyStatistics,
} from "../../../../Services/FamilyDashboardService";

function FamilyDetails(props) {
  const { areaType, selectedLanguageId } = props;
  const {
    userRole,
    districtId: districtHead,
    talukaId: talukaHead,
    phcId: phcHead,
    corporation_council_id: corporationHead,
  } = Object.fromEntries(
    ["userRole", "districtId", "talukaId", "phcId", "corporation_council_id"].map((key) => [
      key,
      sessionStorage.getItem(key),
    ])
  );

  const accessLevel = [
    // English
    { id: 1, name: "State" },
    { id: 2, name: "District" },
    { id: 3, name: "Taluka" },
    { id: 4, name: "PHC" },
    { id: 5, name: "UPHC" },
    { id: 6, name: "Corporation" }, 
    { id: 7, name: "Multi District" },
  ];

  const access_level_id = sessionStorage.getItem("access_level_id");

  const filteredAccessLevel = accessLevel.filter(
    (level) => 
      level.id === Number(access_level_id)
  );

 const accessLevelName = filteredAccessLevel[0].name;

  const [districtOptions, setDistrictOptions] = useState([]);
  const [talukaOptions, setTalukaOptions] = useState([]);
  const [phcOptions, setPhcOptions] = useState([]);
  const [uphcOptions, setUphcOptions] = useState([]);
  const [villageOptions, setVillageOptions] = useState([]);
  const [subcenterOptions, setSubcenterOptions] = useState([]);
  const [corporationOptions,] = useState([]);
  const [lgbOptions, setLgbOptions] = useState([]);
  const [subareaOptions, setSubareaOptions] = useState([]);
  const [district, setDistrict] = useState("");
  const [taluka, setTaluka] = useState("");
  const [phc, setPhc] = useState("");
  const [uphc, setUphc] = useState("");
  const [village, setVillage] = useState("");
  const [subcenter, setSubcenter] = useState("");
  const [corporation, setCorporation] = useState("");
  const [subarea, setArea] = useState("");
  const [lgb, setLgb] = useState("");
  const [levelName, setLevelName] = useState("");
  const [columns, setColumns] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [statisticsData, setStatisticsData] = useState({});
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const IS_RURAL = areaType === "Rural" || areaType === "ग्रामीण";
  const IS_URBAN = areaType === "Urban" || areaType === "शहरी";

  const accessMenus = sessionStorage.getItem("accessMenus");
  const jsonAccessMenus = JSON.parse(accessMenus);
  const menu = jsonAccessMenus.filter((menu) => menu.menuName === "dashboard");

  const familyCountMenu = menu[0].features.familyCount;

  useEffect(() => {
    if (levelName) {
      setColumns([
        {
          header: levelName === 'house' ? levelName.charAt(0).toUpperCase() + levelName.slice(1) + ' No.': levelName.charAt(0).toUpperCase() + levelName.slice(1),
          field: "name",
          filter: true,
          filterPlaceholder: `Search by ${levelName}`,
        },
        {
          header: "No. of Families",
          field: "total_families",
          filter: true,
          filterPlaceholder: "Search by Families",
        },
        {
          header: "Eligible Couples",
          field: "total_eligible_couples",
          filter: true,
          filterPlaceholder: "Search by Eligible Couples",
        },
      ]);
    }
  }, [levelName]);

  useEffect(() => {
    if (accessLevelName === "PHC") {
      setPhc(Number(phcHead));
      setColumns([
        {
          header:
            String(levelName).charAt(0).toUpperCase() +
            String(levelName).slice(1),
          field: "name",
          filter: true,
          filterPlaceholder: "Search by Subcenter",
        },
        {
          header: "No. of Families",
          field: "total_families",
          filter: true,
          filterPlaceholder: "Search by Families",
        },
        {
          header: "Eligible Couples",
          field: "total_eligible_couples",
          filter: true,
          filterPlaceholder: "Search by Eligible Couples",
        },
      ]);
    } else if (accessLevelName === "Corporation") {
      setCorporation(Number(corporationHead));
      setColumns([
        {
          header:
            String(levelName).charAt(0).toUpperCase() +
            String(levelName).slice(1),
          field: "name",
          filter: true,
          filterPlaceholder: `Search by ${levelName}`,
        },
        {
          header: "No. of Families",
          field: "total_families",
          filter: true,
          filterPlaceholder: "Search by Families",
        },
        {
          header: "Eligible Couples",
          field: "total_eligible_couples",
          filter: true,
          filterPlaceholder: "Search by Eligible Couples",
        },
      ]);
    } 
    else if (accessLevelName === "UPHC") {
      setDistrict(Number(districtHead));
      setTaluka(Number(talukaHead));
      setUphc(Number(phcHead));
      setColumns([
        {
          header:
            String(levelName).charAt(0).toUpperCase() +
            String(levelName).slice(1),
          field: "name",
          filter: true,
          filterPlaceholder: "Search by Subcenter",
        },
        {
          header: "No. of Families",
          field: "total_families",
          filter: true,
          filterPlaceholder: "Search by Families",
        },
        {
          header: "Eligible Couples",
          field: "total_eligible_couples",
          filter: true,
          filterPlaceholder: "Search by Eligible Couples",
        },
      ]);
    } else if (accessLevelName === "Taluka") {
      setDistrict(Number(districtHead));
      setTaluka(Number(talukaHead));
      setColumns([
        {
          header:
            String(levelName).charAt(0).toUpperCase() +
            String(levelName).slice(1),
          field: "name",
          filter: true,
          filterPlaceholder: "Search by PHC",
        },
        {
          header: "No. of Families",
          field: "total_families",
          filter: true,
          filterPlaceholder: "Search by Families",
        },
        {
          header: "Eligible Couples",
          field: "total_eligible_couples",
          filter: true,
          filterPlaceholder: "Search by Eligible Couples",
        },
      ]);
    } else if (accessLevelName === "District" || accessLevelName === "Multi District") {
      setDistrict(districtHead);
      setColumns([
        {
          header:
            String(levelName).charAt(0).toUpperCase() +
            String(levelName).slice(1),
          field: "name",
          filter: true,
          filterPlaceholder: "Search by Taluka",
        },
        {
          header: "No. of Families",
          field: "total_families",
          filter: true,
          filterPlaceholder: "Search by Families",
        },
        {
          header: "Eligible Couples",
          field: "total_eligible_couples",
          filter: true,
          filterPlaceholder: "Search by Eligible Couples",
        },
      ]);
    } else if (accessLevelName === "State") {
      setColumns([
        {
          header:
            String(levelName).charAt(0).toUpperCase() +
            String(levelName).slice(1),
          field: "name",
          filter: true,
          filterPlaceholder: "Search by District",
        },
        {
          header: "No. of Families",
          field: "total_families",
          filter: true,
          filterPlaceholder: "Search by Families",
        },
        {
          header: "Eligible Couples",
          field: "total_eligible_couples",
          filter: true,
          filterPlaceholder: "Search by Eligible Couples",
        },
      ]);
    }
  }, [userRole, districtHead, talukaHead, phcHead, corporationHead]);

  const rowsPerPageOptions = [5, 10, 20, 50];
  const defaultRowsPerPage = 10;

  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const stateId = 1;
        if (accessLevelName === "Taluka"){
          setTaluka(Number(talukaHead));
        }
        if (!district && accessLevelName !== "Corporation") {
          const districts = await getAllFamilyDistrict(
            selectedLanguageId,
            stateId
          );
          setDistrictOptions(districts);
        }
        if (!lgb && district && district !== "" && IS_URBAN) {
          const lgbs = await getAllFamilyLgb(selectedLanguageId, areaType);
          setLgbOptions(lgbs);
        }
        if (
          (IS_RURAL && district && district !== "" ) ||
          (IS_URBAN && lgb == 1 )
        ) {
          const talukas = await getAllFamilyTaluka(
            selectedLanguageId,
            district
          );
          setTalukaOptions(talukas);
        }

        if (IS_URBAN && lgb && lgb !== "" && lgb !== 1 && !uphc) {
          const uphcOrPhcs = await getAllFamilyUphcOrPhc(
            selectedLanguageId,
            district,
            taluka,
            areaType,
            lgb
          );
          setUphcOptions(uphcOrPhcs);
        } else if (IS_URBAN && lgb === 1 && taluka !== "" && !uphc) {
          const uphcOrPhcs = await getAllFamilyUphcOrPhc(
            selectedLanguageId,
            district,
            taluka,
            areaType,
            lgb
          );
          setUphcOptions(uphcOrPhcs);
        } else if (IS_RURAL && taluka && taluka !== "") {
          const uphcOrPhcs = await getAllFamilyUphcOrPhc(
            selectedLanguageId,
            district,
            taluka,
            areaType,
            lgb,
          );
          setPhcOptions(uphcOrPhcs);
        }
        if(accessLevelName === "Corporation" && IS_URBAN){
          const uphcOrPhcs = await getAllFamilyUphcOrPhc(
            selectedLanguageId,
            district,
            taluka,
            areaType,
            lgb,
            corporationHead
          );
          setUphcOptions(uphcOrPhcs);
        }
        if (phc && phc !== "" && !subcenter) {
          const subcenters = await getAllFamilySubcenter(
            selectedLanguageId,
            phc
          );
          setSubcenterOptions(subcenters);
        }
        if (IS_RURAL && subcenter && subcenter !== "" && !village) {
          const villages = await getAllFamilyVillageOrSubarea(
            selectedLanguageId,
            subcenter,
            phc
          );
          setVillageOptions(villages);
        } else if (IS_URBAN && uphc && uphc !== "" && !subarea) {
          const subareas = await getAllFamilyVillageOrSubarea(
            selectedLanguageId,
            subcenter,
            uphc
          );
          setSubareaOptions(subareas);
        }
        const getAllFamilyTableData = (accessLevelName === "District" && lgb === 5) ? {} :await getAllFamilyEligibleCouple(
          selectedLanguageId,
          district,
          taluka,
          phc,
          subcenter,
          village,
          lgb,
          areaType,
          uphc,
          subarea,
          corporationHead,
          page,
          pageSize
        );
        if (
          getAllFamilyTableData.data && Array.isArray(getAllFamilyTableData.data.data) &&
          getAllFamilyTableData.data.data.length > 0
        ) {
          setLevelName(getAllFamilyTableData.data.level);
          setTableData(getAllFamilyTableData.data.data);
          setPage(getAllFamilyTableData.data.page);
          setPageSize(getAllFamilyTableData.data.pageSize);
          setTotalCount(getAllFamilyTableData.data.totalCount);
        } else {
          setLevelName("");
          setTableData([]);
          setPage(1);
          setPageSize(10);
          setTotalCount(0);
        }
        const getAllFamilyStatisticsData = (accessLevelName === "District" && lgb === 5) ? {} :await getAllFamilyStatistics(
          selectedLanguageId,
          district,
          taluka,
          phc,
          subcenter,
          village,
          lgb,
          areaType,
          uphc,
          subarea,
          corporationHead
        );
        if (
          Array.isArray(getAllFamilyStatisticsData.data) &&
          getAllFamilyStatisticsData.data.length > 0
        ) {
          setStatisticsData(getAllFamilyStatisticsData.data[0]);
        } else {
          setStatisticsData({
            total_anc_visits: "0",
            total_child_under_5_years: "0",
            total_eligible_couples: "0",
            total_families: "0",
            total_female_30_60: "0",
            total_female_above_60: "0",
            total_hbnc_visits: "0",
            total_hbyc_visits: "0",
            total_male_30_60: "0",
            total_male_above_60: "0",
            total_pnc_visits: "0",
          });
        }
      } catch (error) {}
    };
    fetchData();
  }, [
    selectedLanguageId,
    district,
    taluka,
    areaType,
    lgb,
    uphc,
    phc,
    subcenter,
    subarea,
    village,
    userRole,
    talukaHead,
    corporationHead,
    page,
    pageSize
  ]);

  const pieChartData1 = {
    labels: ["ANC", "PNC"],
    datasets: [
      {
        data: [
          statisticsData.total_anc_visits,
          statisticsData.total_pnc_visits,
        ],
        backgroundColor: ["#3498db", "#2ecc71"],
      },
    ],
  };

  const pieChartData2 = {
    labels: ["HBNC", "HBYC", "Under 5 years"],
    datasets: [
      {
        data: [
          statisticsData.total_hbnc_visits,
          statisticsData.total_hbyc_visits,
          statisticsData.total_child_under_5_years,
        ],
        backgroundColor: ["#f39c12", "#1abc9c", "#9b59b6"],
      },
    ],
  };

  const styles = {
    container: {
      padding: "10px",
      fontFamily: "Arial, sans-serif",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "20px",
    },
    dropdownContainer: {
      marginLeft: "50px",
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      gap: "10px",
    },
    content: {
      display: "flex",
      gap: "20px",
    },
    tableContainer: {
      flex: 1,
    },
    statsContainer: {
      flex: 1,
      border: "1px solid #ddd",
      padding: "10px",
    },
    statsHeader: {
      backgroundColor: "#2c3d8f",
      color: "#fff",
      padding: "5px",
      fontWeight: "bold",
      textAlign: "center",
    },
    eligibleCouples: {
      textAlign: "center",
      margin: "10px 0",
    },
    demographics: {
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      fontSize: "14px",
    },
    chartContainer: {
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      width: "100%",
      gap: "20px",
    },
    chartItem: {
      width: "48%",
    },
    icon: {
      marginRight: "5px",
    },
    paginatorContainer: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "10px",
    },
  };

  const dropdownConfigs = [
    {
      label: "District",
      placeholder: "Select District",
      options: districtOptions,
      visible: true,
      state: [
        district,
        (value) => {
          setDistrict(value);
          setLgb("");
          setTaluka("");
          setUphc("");
          setPhc("");
          setSubcenter("");
          setVillage("");
          setArea("");
          setLgbOptions([]);
          setTalukaOptions([]);
          setUphcOptions([]);
          setPhcOptions([]);
          setSubareaOptions([]);
          setVillageOptions([]);
          setSubcenterOptions([]);
        },
      ],
      disabled: !familyCountMenu.districtDropdown.hasAccess
    },
    {
      label: "LGB Name",
      placeholder: "Select LGB",
      options: lgbOptions,
      visible: IS_URBAN,
      state: [
        lgb,
        (value) => {
          setLgb(value);
          setTaluka("");
          setUphc("");
          setArea("");
          setTalukaOptions([]);
          setUphcOptions([]);
          setSubareaOptions([]);
        },
      ],
      disabled: !familyCountMenu.lgbDropdown.hasAccess,
    },
    {
      label: "Taluka",
      placeholder: "Select Taluka",
      options: talukaOptions,
      visible: IS_RURAL || (IS_URBAN && lgb === 1),
      state: [
        taluka,
        (value) => {
          setTaluka(value);
          setUphc("");
          setPhc("");
          setSubcenter("");
          setVillage("");
          setArea("");
          setUphcOptions([]);
          setPhcOptions([]);
          setSubcenterOptions([]);
          setVillageOptions([]);
        },
      ],
      disabled: !familyCountMenu.talukaDropdown.hasAccess
    },
    {
      label: "UPHC Name",
      placeholder: "Select UPHC",
      options: uphcOptions,
      visible: IS_URBAN,
      state: [
        uphc,
        (value) => {
          setUphc(value);
          setArea("");
        },
      ],
      disabled: !familyCountMenu.uphcDropdown.hasAccess || (lgb == 5 && (accessLevelName === "Taluka" || accessLevelName === "District")),
    },
    {
      label: "PHC Name",
      placeholder: "Select PHC",
      options: phcOptions,
      visible: IS_RURAL,
      state: [
        phc,
        (value) => {
          setPhc(value);
          setSubcenter("");
          setVillage("");
          setSubcenterOptions([]);
          setVillageOptions([]);
        },
      ],
      disabled: !familyCountMenu.phcDropdown.hasAccess,
    },
    {
      label: "Sub Center",
      placeholder: "Select Sub Center",
      options: subcenterOptions,
      visible: IS_RURAL,
      state: [
        subcenter,
        (value) => {
          setSubcenter(value);
          setVillage("");
          setVillageOptions([]);
        },
      ],
    },
    {
      label: "Corporation",
      placeholder: "Select Corporation",
      options: corporationOptions,
      visible: IS_URBAN && familyCountMenu.corporationDropdown.hasAccess,
      state: [
        corporation,
        (value) => {
          setCorporation(value);
        },
      ],
      disabled: !familyCountMenu.corporationDropdown.hasAccess
    },
    {
      label: "Village",
      placeholder: "Select Village",
      options: villageOptions,
      visible: IS_RURAL,
      state: [village, setVillage],
    },
    {
      label: "Sub Area",
      placeholder: "Select Sub Area",
      options: subareaOptions,
      visible: IS_URBAN,
      state: [subarea, setArea],
      disabled: lgb == 5 && (accessLevelName === "Taluka" || accessLevelName === "District")
    },
  ];

  const handlePageChange = (e) => {
    onPageChange(e.page + 1, e.rows);
  };
  const onPageChange = (newPage, newPageSize) => {
    setPage(newPage);
    setPageSize(newPageSize);
  };
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div>
          <div style={styles.dropdownContainer}>
            {dropdownConfigs.map((config, index) => (
              <LabeledDropdown
                key={index}
                label={config.label}
                placeholder={config.placeholder}
                options={config.options}
                visible={config.visible}
                value={config.state[0]}
                onChange={config.state[1]}
                disabled={config.disabled}
              />
            ))}
          </div>
        </div>
      </div>
      <div style={styles.content}>
        <div style={styles.tableContainer}>
          <DataTable
            data-testid="family-details-table"
            className="custom-family-details-table"
            resizableColumns
            selectionMode={"checkbox"}
            value={tableData.length > 0 ? tableData : []}
            size="small"
            filterDisplay="row"
            dataKey="houseNo"
            emptyMessage="No data found."
            scrollable
            scrollHeight="510px"
            paginator
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            rows={pageSize}
            first={(page - 1) * pageSize}
            totalRecords={totalCount}
            rowsPerPageOptions={rowsPerPageOptions}
            paginatorLeft={null}
            paginatorRight={<div style={{ textAlign: "left", width: "100%" }} />}
            onPage={handlePageChange}
          >
            {columns.map((column) => (
              <Column
                key={column.field}
                header={column.header}
                field={column.field}
              />
            ))}
          </DataTable>
          <div style={styles.paginatorContainer}></div>
        </div>
        <div style={styles.statsContainer}>
          <div style={styles.statsContainer}>
            <div style={styles.statsHeader}>Family Statistics</div>
            <div
              style={{
                ...styles.eligibleCouples,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h4>Eligible Couples</h4>
                <h2>{statisticsData.total_eligible_couples}</h2>
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "20px" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <span>
                    People over 30 Female:{" "}
                    <b>{statisticsData.total_female_30_60}</b>
                  </span>
                  <span>
                    People over 60 Female:{" "}
                    <b>{statisticsData.total_female_above_60}</b>
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <span>
                    People over 30 Male:{" "}
                    <b>{statisticsData.total_male_30_60}</b>
                  </span>
                  <span>
                    People over 60 Male:{" "}
                    <b>{statisticsData.total_male_above_60}</b>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div style={styles.chartContainer}>
            <PieChartComponent
              data={pieChartData1}
              title="Maternal Care Case"
            />
            <PieChartComponent
              data={pieChartData2}
              title="Child Care Statistics"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default FamilyDetails;
